import { useEffect } from 'react';

export const useMutationObserver = (
  target,
  callback,
  options = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true,
  }
) => {
  useEffect(() => {
    if (!target) return;

    const observer = new MutationObserver(callback);

    observer.observe(target, options);

    return () => observer.disconnect();
  }, [callback, options]);
};
